import React, { createContext, useState, useContext, useEffect } from 'react';
import translations, { availableLanguages } from '../siteLanguages';

// Standard sprog
const DEFAULT_LANGUAGE = 'english';

// Opret sprogkontekst
const LanguageContext = createContext();

export function useLanguage() {
  return useContext(LanguageContext);
}

export function LanguageProvider({ children }) {
  // Hent gemt sprog fra localstorage eller brug standard
  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('language');
    return savedLanguage && availableLanguages.some(lang => lang.code === savedLanguage)
      ? savedLanguage
      : DEFAULT_LANGUAGE;
  });

  // Opdater localstorage når sprog ændres
  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  // Hent oversættelser for det valgte sprog
  const getTranslation = (page, key, params = {}) => {
    let translation = translations[language]?.[page];
    
    // Hvis der ikke findes en oversættelse, fald tilbage til standard sprog
    if (!translation) {
      translation = translations[DEFAULT_LANGUAGE]?.[page];
    }

    // Hvis nøglen indeholder et punkt (f.eks. 'greeting.morning'), naviger ned i objektet
    if (key.includes('.')) {
      const keys = key.split('.');
      let value = translation;
      
      for (const k of keys) {
        if (!value?.[k]) return key; // Returner nøglen hvis oversættelsen ikke findes
        value = value[k];
      }
      
      // Erstat parametre i strengen (f.eks. {count})
      if (typeof value === 'string') {
        Object.entries(params).forEach(([paramKey, paramValue]) => {
          value = value.replace(`{${paramKey}}`, paramValue);
        });
      }
      
      return value || key;
    }
    
    // Returner oversættelsen eller nøglen hvis oversættelsen ikke findes
    return translation?.[key] || key;
  };

  // Skift sprog
  const changeLanguage = (code) => {
    if (availableLanguages.some(lang => lang.code === code)) {
      setLanguage(code);
    }
  };

  const value = {
    language,
    availableLanguages,
    changeLanguage,
    t: getTranslation // Funktion til at hente oversættelser (t for translate)
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export default LanguageContext; 